export default __webpack_public_path__ + "static/media/arrow.f0afadd0.svg";